import React from 'react'
import AddCandidate from '../add-candidate'
import styles from '../../candidate.module.css'

const CreateCandidateView = () => (
    <div className={styles.content}>
        <AddCandidate />
    </div>
)

export default CreateCandidateView
